/**
 * Client Supabase du miroir CRM.
 *
 * Le miroir vit dans le schéma `mailfox`, jamais dans `public` — d'où
 * `db.schema`, qui fait poser à supabase-js les en-têtes `Accept-Profile` /
 * `Content-Profile` que PostgREST attend. Sans eux, chaque requête viserait
 * `public`, où aucune de ces tables n'existe.
 *
 * La clé publishable est publique par conception : RLS est en `force` et
 * `anon` n'a aucun grant. Seul un JWT `authenticated` dont l'`auth.uid()`
 * satisfait `mailfox.is_owner()` ouvre quoi que ce soit.
 *
 * `storageKey` est distinct de tout le reste : la session Supabase n'a rien
 * à voir avec le token Google du mail, et se révoque indépendamment.
 */

import { createClient } from "@supabase/supabase-js";

const URL = import.meta.env.VITE_SUPABASE_URL;
const KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!URL || !KEY) {
  throw new Error(
    "VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY absents — cf. .env.development",
  );
}

export const supabase = createClient(URL, KEY, {
  db: { schema: "mailfox" },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false, // le callback OAuth de la page appartient à Google
    storageKey: "mailfox:crm-auth",
  },
});
